import * as React from 'react';
const IconArrowRight = (props) => (
  <svg
    width={26}
    height={42}
    viewBox="0 0 26 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ width: '26px', height: '42px' }}
    {...props}
  >
    <path d="M5 37L21 21L5 5" stroke="white" strokeWidth={10} strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
export default IconArrowRight;
